import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PaginatorComponent } from 'src/app/components/paginator/paginator.component';
import { Configuration } from 'src/app/models/configurations/configuration';
import { Constants } from 'src/app/models/constants';
import { KeyValueMap } from 'src/app/models/key-value-map';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ConfigurationDetailsComponent } from '../../configuration-details/configuration-details.component';
import { MatDialog } from '@angular/material/dialog';
import { ConfigurationApplicationStatus } from 'src/app/models/configurations/configuration-state';
import { Instance } from 'src/app/models/instance/instance';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { Permission } from 'src/app/models/principal/permission';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { DeploymentClass } from 'src/app/models/instance-class';
import { DataZone } from 'src/app/models/data-zone/data-zone';
import { Attributes, Datazone } from 'src/app/models/principal/permission';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { Permissions } from 'src/app/models/principal/permission';
import { FeatureKeys } from 'src/app/models/feature/feature-keys';
import { Feature, FeatureAttributes, FeatureDatazone } from 'src/app/models/feature/feature';
import { FeaturePermissionsService } from 'src/app/services/util/feature-permissions.service';
import { EnvironmentPaginatorComponent } from 'src/app/main/environment-details/environment-paginator/environment-paginator.component';
import { Router } from '@angular/router';
import { trigger, transition, style, animate } from '@angular/animations';
import { EnvironmentTableComponent } from 'src/app/main/environment-details/environment-table/environment-table.component';
import { translate } from '@jsverse/transloco';
import { AvailabilityStatus } from 'src/app/models/availability-status';

const REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.INSTANCE_TEST_DATAZONE_NONPII,
    action: Permissions.INSTANCE_TEST,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_TEST_DATAZONE_PII,
    action: Permissions.INSTANCE_TEST,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.INSTANCE_TEST_DATAZONE_LIVE,
    action: Permissions.INSTANCE_TEST,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
];

const REQUIRED_FEATURES = [
  {
    key: FeatureKeys.RVT_TEST_NONPII,
    name: Feature.RVT_TEST,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.NONPII
  },
  {
    key: FeatureKeys.RVT_TEST_PII,
    name: Feature.RVT_TEST,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.PII
  }
];

@Component({
    selector: 'app-instance-execute-rvt',
    templateUrl: './instance-execute-rvt.component.html',
    styleUrls: ['./instance-execute-rvt.component.scss'],
    animations: [
        trigger('rotate', [
            transition('void=>*', [style({ transform: 'rotate(0)' })]),
            transition('* => *', [
                style({ transform: 'rotate(0)' }),
                animate('650ms ease-in-out', style({ transform: 'rotate(360deg)' })),
            ])
        ])
    ],
    standalone: false
})
export class InstanceExecuteRvtComponent  implements OnInit {
  @ViewChild(PaginatorComponent, { static: true }) paginator: PaginatorComponent;
  @ViewChild(EnvironmentPaginatorComponent)paginatorRef: EnvironmentPaginatorComponent;
  @ViewChild(EnvironmentTableComponent) tableRef: EnvironmentTableComponent;
  @Output() executeRvtClick = new EventEmitter();
  @Output() refreshClick = new EventEmitter();
  @Input() instance: Instance;

  @Input() configs: any[];
  @Input() isInstance: boolean;
  @Input() configLoaded: boolean;
  pageIndex = 0;
  paginationSize = 10;
  private destroyRef = inject(DestroyRef);
  ConfigurationApplicationStatus = ConfigurationApplicationStatus;

  configurations: any[];
  pageConfigurations: Configuration[];
  filteredConfigurations: Configuration[];
  expandedRows: KeyValueMap<string, boolean> = {};

  selection: Configuration;
  Constants = Constants;
  deploymentClass = DeploymentClass;
  Permission = Permission;

  inProgress = false;
  searchValue: string;
  selectedId: any;
  disableSelect = false;
  permissionsMap: { [key: string]: boolean };
  DataZone = DataZone;
  DeployStatus = DeployStatus;
  PermissionKeys = PermissionKeys;
  FeatureKeys = FeatureKeys;
  featuresMap: { [key: string]: boolean };
  isLoading: boolean;
  count: number;
  rvtConfigData: any;
  searchedResult = [];
  AvailabilityStatus = AvailabilityStatus;
  displayColumns =[
    {
      key: 'selected',
      name: '',
      type: 'radioSelection',
      sortable: false,
      visible: true,
      disable: false
    },
    {
      key: 'name',
      name: 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.RELEASE_PACKAGE_NAME',
      type: 'text',
      sortable: true,
      visible: true,
      disable: true,
      keyLink: 'navigation'
    },
    {
      key: 'version',
      name: 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.VERSION',
      type: 'text',
      sortable: true,
      visible: true,
      disable: true,
    },
    {
      key: 'dateGenerated',
      name: 'INSTANCE_DETAILS.UPDATE_CONFIGURATION.DATE_GENERATED',
      type: 'date',
      sortable: true,
      visible: true,
      disable: true,
    },
    {
      key: 'status',
      name: '',
      type: 'status',
      sortable: false,
      visible: true,
      disable: true,
    },
    {
      key: 'applyRvtConfig',
      name: '',
      type: 'applyRvtConfig',
      sortable: false,
      visible: true,
      disable: false,
    }
  ];
  readonly ACTION_NOT_ALLOWED_STATES = [DeployStatus.STARTING, DeployStatus.STOPPED, DeployStatus.STOPPING, DeployStatus.START_FAILED, DeployStatus.INITIALIZE_FAILED, DeployStatus.INITIALIZED, DeployStatus.INITIALIZING];

  constructor(public sidenavService: SidenavService, public datepipe: DatePipe, private changeDetectorRef: ChangeDetectorRef,
    private matDialog: MatDialog, private permissionsService: PermissionsService, private featurePermissionsService: FeaturePermissionsService) {
    
  }

  @Input() set executeRvtInProgressing(applyConfigInProgress) {
    this.inProgress = applyConfigInProgress;
  };

  @Input() set availableConfigurationsForRvt(availableConfigurations: Configuration[]) {
    this.configurations = availableConfigurations !== undefined ? [...availableConfigurations] : [];
    if (!this.selectedId){
      this.updateSelectedPack();
    }
    const selected = this.configurations?.find(item => item?.id === this.selectedId);
    this.configurations.sort(this.defaultComparator);
    if(selected) {
    this.configurations = this.configurations?.filter(item => item?.id !== this.selectedId);
    this.configurations = [selected, ...this.configurations];
    this.setFlagValues(selected);
    this.disableSelect = true;
  }
  if (this.instance && this.instance?.status !== DeployStatus.TESTED && this.instance?.status !== DeployStatus.CONFIGURED &&
    this.instance?.status !== DeployStatus.DEPLOYED && this.instance?.status !== DeployStatus.CONFIGURATION_FAILED &&
    this.instance?.status !== DeployStatus.TEST_FAILED && this.instance?.status !== DeployStatus.UPDATED) {
    this.disableSelect = true;
  }
    this.search(this.searchValue);
    if (!this.isInstance) {
      this.modifyConfiguration();
    }
    this.changeDetectorRef.detectChanges();
  }

  ngOnInit(): void {
    this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    this.featuresMap = this.featurePermissionsService.resolveFeaturePermissions(REQUIRED_FEATURES);
    const selected = this.configurations?.find(config => config?.id === this.instance?.latestRvtState?.configurationId
      && config?.status === 'inprogress');
    if (selected) {
      this.selectedId = selected?.id;
      this.selection = selected;
      this.configurations = this.configurations?.filter(item => item?.id !== this.selectedId);
      this.configurations = [selected, ...this.configurations];
      this.setFlagValues(this.selection);
      this.disableSelect = true;
    }
    if (this.instance && this.instance?.status !== DeployStatus.TESTED && this.instance?.status !== DeployStatus.CONFIGURED &&
      this.instance?.status !== DeployStatus.DEPLOYED  && this.instance?.status !== DeployStatus.CONFIGURATION_FAILED &&
      this.instance?.status !== DeployStatus.TEST_FAILED && this.instance?.status !== DeployStatus.UPDATED) {
        this.disableSelect = true;
      }
      if (this.isInstance && this.paginator) {
      this.paginator.page
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(pageEvent => {
        const startIndex = pageEvent.pageIndex * pageEvent.pageSize;
        this.pageConfigurations = this.filteredConfigurations.slice(startIndex, startIndex + pageEvent.pageSize);
        if (!this.pageConfigurations.includes(this.selection)) {
        }
        this.changeDetectorRef.detectChanges();
      });
       } else {
    const element = <HTMLElement> document.getElementsByClassName("config-paginator")[0];
    if (element) {
      element.style.display = 'none';
    }
    this.modifyConfiguration();
  }
      this.search();
  }

  setFlagValues(selected): void {
    if (selected?.status === ConfigurationApplicationStatus.CONFIGURING ||
      selected?.status === ConfigurationApplicationStatus.CONFIGURED ||
      selected?.status === ConfigurationApplicationStatus.TESTING || selected?.status === ConfigurationApplicationStatus.VERIFYING ||
      (this.instance && this.instance?.status !== DeployStatus.TESTED && this.instance?.status !== DeployStatus.CONFIGURED &&
      this.instance?.status !== DeployStatus.DEPLOYED && this.instance?.status !== DeployStatus.CONFIGURATION_FAILED &&
      this.instance?.status !== DeployStatus.TEST_FAILED && this.instance?.status !== DeployStatus.UPDATED)) {
        this.disableSelect = true;
    } else if (selected?.status === ConfigurationApplicationStatus.TEST_FAILED ||
        selected?.status === ConfigurationApplicationStatus.SUCCESS) {
      this.disableSelect = false;
    };
  }

  refreshInstanceForm(): void {
    this.isLoading = true;
    this.refreshClick.emit();
    this.isLoading = false;

    this.count = this.count !== 1 ? 1 : 0;
    if(!this.isInstance){
      if (this.paginatorRef) {
        this.paginatorRef.pageIndex = 0;
      }
      this.resetPaginator();
    }
    this.updateSelectedPack();
  }

  expandRow(configuration: Configuration): void {
     this.expandedRows[configuration.id] = !this.expandedRows[configuration.id];
  }

  configurationNameClick(configuration: any): void {
    configuration.instanceName = this.instance.name;
    const isRvt = true;
    this.matDialog.open(ConfigurationDetailsComponent, {
      height: '50vh',
      width: '40vw',
      panelClass: 'flex-dialog',
      data: {
        configuration,
        isRvt
      }
    });
  }

  /**
   * Performs a simple search in the list of configurations
   *
   * @param value Method that filters displayed configurations based on search criteria.
   */
  search(value?: string): void {
    if(value) {
      this.searchValue = value.trim().toLowerCase();
      this.filteredConfigurations = this.configurations.filter(config =>{
        let dateMatch = false;
        if (config.manifest?.dataGenerated) {
          const formatted = new Date(config.manifest?.dataGenerated).toLocaleString('en-GB', {day: '2-digit',month: 'short',year: '2-digit',hour: '2-digit',minute: '2-digit',second: '2-digit',hour12: false,timeZone: 'UTC'}).replace(',', '');
          const dateWithOffset = `${formatted} +0000`.toLowerCase();
          dateMatch = dateWithOffset.includes(this.searchValue);
        }
        return  config.manifest.name.toLowerCase().includes(this.searchValue) ||
        config.manifest.version.toLowerCase().includes(this.searchValue) || dateMatch
    });
    } else {
      this.searchValue = '';
      this.filteredConfigurations = this.configurations;
    }

    // Clear selection when page is changed
    if (this.selection && !this.filteredConfigurations.includes(this.selection)) {
      // this.selection = null;
    }

    // If there is only one configuration select it by default
    if (this.filteredConfigurations.length === 1) {
      this.selection = this.filteredConfigurations[0];
    }
    if(this.isInstance) {
      this.paginator.length = this.filteredConfigurations.length;
    }
  }

  /**
   * Changes the selection each time we click on a row
   *
   * @param row - the selected row
   */
  select(row): void {
    this.selection = row;
    this.modifyConfiguration();
  }

  /**
   * Applies the selected configuration
   */
  executeRvt(configuration): void {
    this.selection = configuration
    this.selectedId = this.selection.id;
    const selectedConfiguration = this.selection;
    this.executeRvtClick.emit(selectedConfiguration);
  }

  private defaultComparator(config1: Configuration, config2: Configuration): number {
    if (config1?.manifest?.dataGenerated && config2?.manifest?.dataGenerated) {
      return new Date(config2.manifest.dataGenerated).getTime() - new Date(config1.manifest.dataGenerated).getTime();
    }
    return 0;
  }
  /**
   * Updates local pagination state (page size and index)
   * Delegates the pagination event to the table reference to trigger data reload or view update
   */
  onPageChange(event) {
    this.paginationSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.tableRef?.pageChanged(event);
  }
  //Updates local pagination state (page size and index)
  resetPaginator() {
    this.paginationSize = 10;
    this.pageIndex = 0;
    this.paginatorRef.pageIndex = 0;
  }
   //Updates local pagination state (page size and index)
  onTablePageChanged(event) {
    this.pageIndex = event.pageIndex;
    this.paginationSize = event.pageSize;
  }
  /**
   * Prepares normalized row data for the shared table component.
   * Enforces consistent row structure: same keys for all rows,
   * values vary based on selection and state.
  */
  modifyConfiguration() {
    if(!this.permissionsMap) {
      this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    }
    if(!this.featuresMap) {
      this.featuresMap = this.featurePermissionsService.resolveFeaturePermissions(REQUIRED_FEATURES);
    }
    const disableAction = this.ACTION_NOT_ALLOWED_STATES.includes(this.instance?.status);
    this.rvtConfigData = this.configurations?.map(config => {
      let status = "";
      if (this.selection?.id === config?.id) {
        if (this.inProgress || ((config.status === 'inprogress' || config.status === ConfigurationApplicationStatus.TESTING) &&
            config.status !== ConfigurationApplicationStatus.TEST_FAILED && config.status !== ConfigurationApplicationStatus.FAILED)) {
          status = translate('CONFIGURATIONS.STATE.EXECUTING_RVTS');
        }
        if (!this.inProgress && config.status && (config.status === ConfigurationApplicationStatus.TEST_FAILED || config.status === ConfigurationApplicationStatus.FAILED)) {
          status = translate('CONFIGURATIONS.STATE.TEST_FAILED');
        }
      }
      return {
        id:config?.id,
        selected: this.selection?.id === config?.id,
        name: config?.manifest?.name,
        version: config?.manifest?.version,
        dateGenerated: config?.manifest?.dataGenerated,
        status: status,
        configuration: config,
        havePermission: ((this.instance?.dataZone === DataZone.DEVELOPMENT && this.permissionsMap[PermissionKeys.INSTANCE_CONFIG_DATAZONE_NONPII]) || (this.instance?.dataZone === DataZone.SECURE && this.permissionsMap[PermissionKeys.INSTANCE_CONFIG_DATAZONE_PII]) || (this.instance?.dataZone === DataZone.LIVE && this.permissionsMap[PermissionKeys.INSTANCE_CONFIG_DATAZONE_LIVE])),
        disableSelection : (this.inProgress || this.disableSelect) || ((this.instance?.dataZone === DataZone.DEVELOPMENT && !this.permissionsMap[PermissionKeys.INSTANCE_TEST_DATAZONE_NONPII])
        || (this.instance?.dataZone === DataZone.SECURE && !this.permissionsMap[PermissionKeys.INSTANCE_TEST_DATAZONE_PII])
        || (this.instance?.dataZone === DataZone.LIVE && !this.permissionsMap[PermissionKeys.INSTANCE_TEST_DATAZONE_LIVE])),
        showActions : !this.disableSelect && ((this.instance?.dataZone === DataZone.DEVELOPMENT && this.permissionsMap[PermissionKeys.INSTANCE_TEST_DATAZONE_NONPII] && this.featuresMap[FeatureKeys.RVT_TEST_NONPII])
                || (this.instance?.dataZone === DataZone.SECURE && this.permissionsMap[PermissionKeys.INSTANCE_TEST_DATAZONE_PII] && this.featuresMap[FeatureKeys.RVT_TEST_PII])
                || (this.instance?.dataZone === DataZone.LIVE && this.permissionsMap[PermissionKeys.INSTANCE_TEST_DATAZONE_LIVE])),
        disableExecute: disableAction,
        showExecute: !this.inProgress && config.status !== ConfigurationApplicationStatus.TESTING && config.status !== ConfigurationApplicationStatus.TEST_FAILED && config.status !== ConfigurationApplicationStatus.FAILED,
        disableRetry: disableAction,
        showRetry: config.status === ConfigurationApplicationStatus.TEST_FAILED || config.status === ConfigurationApplicationStatus.FAILED,
      };
    });   
  }
    /**
   * Calls filter function when search term changes for components
   * @param - the search term entered
   */
  searchedItems(result): void {
    this.searchedResult = result;
    this.changeDetectorRef.detectChanges();
  }
  // updating the selected package - page refresh / config updation 
  updateSelectedPack(){
    const selectedRvtPack = this.configurations?.find(config => config?.id === this.instance?.latestRvtState?.configurationId && config?.status === 'inprogress');
    if (selectedRvtPack) {
      this.selectedId = selectedRvtPack?.id;
      this.selectedId = selectedRvtPack?.id;
      this.selection = selectedRvtPack;
    } else {
      this.selectedId = undefined;
      this.selection = undefined;
    }
  }
}
